import React, { useEffect, useState, useRef } from 'react';
import { CloseRounded } from '@material-ui/icons';
import styles from './styles';
import closeIcon from '../../../assets/img/closeIcon.svg';
import {
  Modal,
  Box,
  FormControlLabel,
  Checkbox,
  IconButton,
  CircularProgress,
} from '@material-ui/core';
import { useOutsideAlerter } from '@/hocs';
import { Tooltip, Grid, TextField, Button } from '@material-ui/core';
import clsx from 'clsx';
import { TextareaAutosize, FormControl } from '@mui/material';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import {
  adminUploadHtmlToScrape,
  orderApprove,
  orderConfirm,
  uploadContainerImages,
  SaveApiResMessage,
} from '@/actions';
import { Loading, useNotify } from 'react-admin';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';
import SubmitButton from '@/ctComponents/submitButton';
import CloseButton from '@/ctComponents/closeButton';

export default ({
  Close,
  orderID,
  RejectEmpty,
  mode,
  setLoadingCircle,
  loadingCircle,
  chatType,
  orderDetail,
}) => {
  useEffect(() => {
    !loadingCircle && setLoading(false);
  }, [loadingCircle]);

  const cls = styles();
  const wrapperRef = useRef(null);
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => {
    if (state) {
      const user = state.reducer?.user;
      return user;
    }
  });

  const [formData, setFormData] = useState(
    chatType === 'request'
      ? {
          'Container not in acceptable condition.': false,
          'Container not available at listed location.': false,
          'Shipping line approval revoked.': false,
          'Time constraints prevented completion.': false,
          'Export booking canceled or modified.': false,
          'Unexpected high per diem fees.': false,
          'Other reasons': false,
          Otherreasonsmessage: '',
        }
      : {
          'Container gated in before pickup.': false,
          'Operational issues prevented release.': false,
          'Container was already assigned elsewhere.': false,
          'Container used for dual transaction.': false,
          'Container moved to a different location.': false,
          'Trucking company lost equipment.': false,
          'Other reasons': false,
          Otherreasonsmessage: '',
        }
  );

  const dipute = (orderID) => {
    // Check if at least one option is selected
    const selectedOptions = Object.keys(formData).filter(
      (key) => key !== 'Otherreasonsmessage' && formData[key] === true
    );

    if (selectedOptions.length === 0) {
      SaveApiResMessage({
        title: 'Warning',
        message: 'Please select at least one reason for the dispute.',
        mode: 'warning',
      });
      return;
    }

    // Check if "Other reasons" is selected but message is empty
    if (formData['Other reasons'] && !formData.Otherreasonsmessage.trim()) {
      // notify('Please enter your reason in the text area.', 'warning');
      SaveApiResMessage({
        title: 'Warning',
        message: 'The reason must be entered in the text area to proceed.',
        mode: 'warning',
      });
      return;
    }
    setLoading(true);

    const isConfirm = false;
    orderConfirm(orderID, { accept: isConfirm, data: formData }).then((res) => {
      setLoading(false);
      if (res) {
        // notify(
        //   `Successfully ${isConfirm ? 'confirmed' : 'disputed'}`,
        //   'success'
        // );
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          // message: `Successfully ${isConfirm ? 'confirmed' : 'disputed'}`,
          message: res?.message,
          mode: 'success',
        });
        Close();
      }
    });
  };

  const handleCheckboxChange = (name) => (event) => {
    const { checked } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: checked,
    }));
  };

  return (
    <div className={cls.popup}>
      <div className={cls.uploadImageCard}>
        <Tooltip arrow title="Close" placement="top">
          <CloseRounded className={cls.closeP} onClick={Close} />
        </Tooltip>
        <div ref={wrapperRef} className={cls.popupCard}>
          <span className={cls.tableTopActions}>
            <ReactSVG src={Icons.declineIcon} className={cls.dicsounticon} />
            {mode === 'dispute'
              ? 'Dispute Confirmation'
              : 'Decline Confirmation'}
          </span>
          {mode === 'dispute' ? (
            <span className={cls.disputeTextSpan}>
              <span className={cls.disputeTex}>
                Dear <span style={{ fontWeight: 'bold' }}>{user.company}</span>,
                please select or type your reason for the dispute.
              </span>
              {Object.keys(formData).map((key) =>
                key !== 'Otherreasonsmessage' ? (
                  <div key={key} className={cls.inputGroup}>
                    <Checkbox
                      checked={formData[key]}
                      onChange={handleCheckboxChange(key)}
                      className={cls.checkbox}
                    />
                    <label className={cls.label}>{key}</label>
                  </div>
                ) : null
              )}

              {formData['Other reasons'] && (
                <FormControl className={cls.radioBtns}>
                  <TextareaAutosize
                    className={cls.inputTextArea}
                    placeholder="Enter your reason..."
                    value={formData.Otherreasonsmessage ?? ''}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData((prev) => ({
                        ...prev,
                        Otherreasonsmessage: value,
                      }));
                    }}
                    minRows={4}
                    maxRows={4}
                    maxLength={200}
                  />
                </FormControl>
              )}
            </span>
          ) : (
            <span className={cls.declineTextSpan}>
              {'Are you sure you want to Decline?'}
            </span>
          )}
        </div>
        {mode === 'dispute' ? (
          <div className={cls.disputePopupBtns} style={{ marginTop: '20px' }}>
            <span className={cls.warning}>
              This information is for Smart Turn’s internal use only and won’t
              be shared with the other party.
            </span>

            <div className="flex items-center gap-1">
              <CloseButton
                color="#131517"
                onClick={() => Close()}
                text="Cancel"
              />

              <SubmitButton
                loading={loading}
                onClick={() => dipute(orderID)}
                text="Confirm"
              />
            </div>
          </div>
        ) : (
          <div className={cls.declinePopupBtns} style={{ marginTop: '20px' }}>
            <CloseButton
              color="#131517"
              onClick={() => Close()}
              text="No, Cancel"
            />

            <SubmitButton
              loading={loading}
              onClick={() => {
                setLoading(true);
                RejectEmpty(orderID);
              }}
              text="Yes, Decline"
            />
          </div>
        )}{' '}
      </div>
    </div>
  );
};
